<template>
    <div class="message-view">
        <div :class="[
                        'c-message_kit__background',
                        'p-message_pane_message__message',
                        'c-message_kit__message',
                        ]">
            <div class="c-message_kit__hover">
                <div class="slack-msg">
                    <div class="slack-msg-actions columns is-gapless">
                        <slack-icon-button icon="add-reaction" />
                        <slack-icon-button icon="comment-alt" />
                        <slack-icon-button
                            :icon="message.is_starred ? 'bookmark-filled': 'bookmark'"
                            @click="handle_star(message)"
                        />
                        <o-dropdown
                            position="bottom-left"
                            aria-role="menu"
                        >
                            <slack-icon-button
                                icon="vertical-ellipsis"
                                slot="trigger"
                            />
                            <o-dropdown-item
                                aria-role="menuitem"
                                @click="turnoff_notifications(message)"
                            >{{ (!message.notifications_disabled ? "Turn off notifications for replies" : "Get notified about new replies") }}
                            </o-dropdown-item>
                            <hr
                                class="dropdown-divider"
                                aria-role="menuitem"
                            />
                            <o-dropdown-item
                                aria-role="menuitem"
                                @click="handle_pin(message)"
                            >
                                {{ !is_pinned(message, channel) ? "Pin to this conversation" : "Up-pin from this conversation" }}
                            </o-dropdown-item>
                            <o-dropdown-item
                                aria-role="menuitem"
                                class="is-danger"
                            >
                                <button
                                    class="
                                            c-button-unstyled
                                            p-message_actions_menu__delete_message
                                            c-menu_item__button
                                            c-menu_item__button--danger
                                        "
                                    role="menuitem"
                                    tabindex="-1"
                                    type="button"
                                >
                                    <div
                                        class="c-menu_item__label"
                                        @click="confirm_delete_message(message)"
                                    >
                                        Delete message
                                    </div>
                                </button>
                            </o-dropdown-item>
                        </o-dropdown>
                        <div class="column"></div>
                    </div>
                    <div class="slack-msg-user-icon">
                        <img
                            :src="message.user_info.profile.image_48"
                            alt="Profile"
                        />
                    </div>
                    <div class="slack-msg-content">
                        <span class="slack-msg-user-name">{{
                            message.user_info.real_name
                        }}</span>
                        <span class="slack-msg-time">{{
                            get_msg_time(message)
                        }}</span>
                        <br />
                        <div
                            class="slack-msg-text"
                            v-html="get_message(message)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { delete_message, get_message, get_msg_time, is_pinned, list_conversation, pin, star, unpin, unstar } from '../../slack_api'
import SlackIconButton from '../SlackIconButton.vue'
export default {
    components: {
        SlackIconButton,
    },
    computed: {
        ...mapGetters([
            'slack_channels',
            'slack_is_signed_in',
        ]),
    },
    data() {
        return {
            now: new Date(),
        }
    },
    methods: {
        confirm_delete_message() {
            return this.confirmMessage(
                'Confirm action',
                'Confirm delete message?',
                'Yes'
            ).then(() => {
                delete_message(this.channel, this.message.ts).then(({ ok }) => {
                    if (!ok) {
                        this.errorMessage('Error deleting message')
                        return
                    }
                    this.update_item(this.message)
                    this.successMessage('Message deleted successfull')
                }, () => this.errorMessage('Error deleting message'))
            }, r => Promise.reject(r))
        },
        get_message,
        get_msg_time,
        handle_pin(msg) {
            if (is_pinned(msg)) {
                this.confirmMessage('Remove pinned item', 'Are you sure you want to remove this pinned item?').then(() => {
                    unpin(msg.ts, this.channel).then(() => {
                        this.update_item(msg)
                    })
                })
            } else {
                pin(msg.ts, this.channel).then(r => {
                    if (r.ok) {
                        this.update_item(msg)
                    } else {
                        this.errorMessage('Message could not be pinned')
                    }
                })
            }
        },
        handle_star(msg) {
            const fn = msg.is_starred ? unstar : star
            fn(msg.ts, this.channel).then(({ ok }) => ok && this.update_item(msg))
        },
        is_pinned,
        same_day(ts1, ts2) {
            return moment(ts1).format('dddd, MMMM Do') === moment(ts2).format('dddd, MMMM Do')
        },
        turnoff_notifications(item) {
            item.notifications_disabled = !item.notifications_disabled
            this.$forceUpdate()
        },
        update_item(msg) {
            list_conversation(this.channel, { inclusive: true, latest: msg.ts, limit: 1 }).then(response => {
                if (!response.ok) {
                    return
                }
                const { messages } = response
                messages.length && this.$emit('updated', messages[0])
            })
        },
    },
    mounted() {
        if (this.slack_is_signed_in) {
        }
    },
    props: ['channel', 'message'],
    unmounted() {
    },
    watch: {
    },
}
</script>
<style lang="sass">
.message-view
  .c-message_kit__labels--pinned, .c-message_kit__labels--starred
    display: none
  .c-message_kit__background--labels
    .c-message_kit__labels--pinned, .c-message_kit__labels--starred
      display: flex
  .slack-msg
    display: flex
    line-height: 1.46668
    padding: 8px 20px
    position: relative
    &:hover
      background-color: rgb(248, 248, 248)
      .slack-msg-actions
        display: flex
    .slack-msg-actions
      --saf-0: rgba(29,28,29,0.13)
      background-color: #fff
      border: unset
      border-radius: 0.375em
      box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08)
      display: none
      padding: 2px
      position: absolute
      right: 17px
      top: -28px
      >.dropdown
        font-size: 15px
        >.dropdown-menu
          >.dropdown-content
            width: 300px
            >a.dropdown-item
              &:hover
                color: #fff
                text-decoration: none
                &:is(.is-danger)
                  background-color: #e01e5a
                &:not(.is-danger)
                  background-color: #1264a3
                button
                  color: #fff
    .slack-msg-content
      font-weight: 400
      .slack-msg-user-name
        font-weight: 900
      .slack-msg-time
        font-size: 12px
      .slack-msg-text
        .slack-mention
          background-color: #1d9bd11a
          border-radius: 3px
          color: #1264a3
          padding: 0 2px 1px 2px
          &.me
            background-color: #f2c74466
    .slack-msg-user-icon
      height: 36px
      margin-right: 8px
      min-width: 36px
      width: 36px
      > img
        border-radius: 4px
</style>